import {AfterViewInit, Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {
  AccountMappingType,
  AccountService,
  AccountTypeName, AddressType, CommonDataService, CommonTransformationService,
  EnumType,
  Format,
  GrowlType, ItemCatalog,
  ItemCatalogService,
  PrimeNgConfig,
  RefDomainType,
  RouteParam,
  TableColumn,
  TableFormat,
  Validation
} from "@app/shared";
import {InvoiceImportDefaultSetting, InvoiceImportItemMapping} from "@app/shared/classes/dataimport/invoice-import-item";
import {ImportDataService} from "@app/shared/import/data-import/import-data.service";
import {GrowlService} from "@app/core";
import {SelectItem, TreeNode} from "primeng/api";
import {plainToClass} from "class-transformer";
import {CatalogDashboard} from "@app/item-catalog/item-catalog";
import {forkJoin} from "rxjs/internal/observable/forkJoin";

@Component({
  selector: 'app-invoice-default-configuration',
  templateUrl: './invoice-default-configuration.component.html',
  styleUrls: ['./invoice-default-configuration.component.css'],
  providers: [ItemCatalogService]
})
export class InvoiceDefaultConfigurationComponent implements OnInit,AfterViewInit {

  Format: typeof Format = Format;
  PrimeNgConfig = PrimeNgConfig;
  Validation: typeof Validation = Validation;
  AccountMappingType: typeof AccountMappingType = AccountMappingType;

  tableColumns: TableColumn[] = [];
  existingItemMappings: InvoiceImportItemMapping[];

  displayCatalogSelectionDialog: boolean = false;
  itemCatalogTreeNodes: TreeNode[];
  unitsDropdown: SelectItem[];






  defaultConfiguration: InvoiceImportDefaultSetting;

  @ViewChild('ledgerAccountTemplate') ledgerAccountTemplate: TemplateRef<any>;



  constructor(private importService: ImportDataService, private catalogService: ItemCatalogService,private growl: GrowlService,
              private accountService: AccountService, private transform: CommonTransformationService,
              private commonDataService: CommonDataService) { }


  ngOnInit(): void {
    this.buildTableColumns();
    this.buildDropDown();
    this.getDefaultConfiguration();
    this.getCatalogs()
  }

  ngAfterViewInit(): void {
    this.buildTableColumns();
  }

  private getCatalogs(): void {
    this.catalogService.getCatalogs().subscribe(res => {
      this.itemCatalogTreeNodes = this.transform.convertToTree("name", res);
    });
  }

  onSelectCatalogNode(catalogNode: TreeNode<ItemCatalog>) {
    this.defaultConfiguration.catalogName = catalogNode.label;
    this.defaultConfiguration.catalogId = catalogNode.data.id;
    this.displayCatalogSelectionDialog = false;
  }

  buildTableColumns(){
    this.tableColumns = [
      {field: 'itemType', header: 'Item Type', format: TableFormat.TitleCase},
      {field: 'codeType', header: 'Code Type', format: TableFormat.TitleCase},
      {field: 'accountMappingType', header: 'Account Mapping Type', format: TableFormat.TitleCase},
      {field: 'ledgerAccountId', header: 'Ledger Account', template: this.ledgerAccountTemplate},
    ];
  }

  buildDropDown() {
    forkJoin(
      this.commonDataService.getRefCodeAsDropdown(RefDomainType.UnitOfMeasure, false, false, false, "description"),
    ).subscribe((
      [unitsDropDown]) => {

      this.unitsDropdown = <SelectItem<number>[]>unitsDropDown;
    });
  }

  getDefaultConfiguration() {
    this.importService.getDefaultVendorInvoiceImportConfiguration().subscribe(res => {
      this.defaultConfiguration = res;
    });
  }

  refreshDefaultConfiguration() {
    this.importService.refreshDefaultVendorInvoiceImportConfiguration().subscribe(res => {
      this.defaultConfiguration = res;
      this.growl.add(GrowlType.Success, "Configuration Refreshed Successfully");
    });
  }

  saveDefaultConfiguration() {
    this.importService.saveDefaultVendorInvoiceImportConfiguration(this.defaultConfiguration).subscribe(res => {
      this.defaultConfiguration = res;
      this.growl.add(GrowlType.Success, "Configuration Updated Successfully");
    });
  }





}
